module.exports = __webpack_public_path__ + "assets/img/btn-give.b87e8239.png";